module.exports = __webpack_public_path__ + "static/media/gb9.09d88485.png";